var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconlist.indexOf(_vm.iconClass) >= 0)?_c('svg',{class:_vm.svgClass,attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})]):_c('i',{staticClass:"svg-icon",class:_vm.iconClass})
}
var staticRenderFns = []

export { render, staticRenderFns }